import React, { useState } from 'react';
import { Sparkles, Users, Star, ChevronDown, LayoutDashboard, Shield, LogOut, User as UserIcon, BookOpen, Briefcase, HelpCircle, Building, Info, FileText, Mail, Heart, Calendar, Sun, MessageSquare } from 'lucide-react';
import { User } from '../../../types';
interface MobileMenuProps {
  handleNavClick: (page: string) => void;
  currentPage: string;
  t: (key: string) => string;
  user: User | null;
  isLoggedIn: boolean;
  onLogout: () => void;
  langOptions: {
    code: string;
    label: string;
    shortLabel: string;
    flag: string;
  }[];
  language: string;
  setLanguage: (lang: string) => void;
  items?: any[];
  removeItem?: (id: string) => void;
  formatPrice?: (p: number) => string;
  cartTotal?: number;
}
export function MobileMenu({
  handleNavClick,
  currentPage,
  t,
  user,
  isLoggedIn,
  onLogout,
  langOptions,
  language,
  setLanguage
}: MobileMenuProps) {
  const [openAccordion, setOpenAccordion] = useState<string | null>(null);
  const toggleAccordion = (id: string) => {
    setOpenAccordion(openAccordion === id ? null : id);
  };
  const accordions = [{
    id: 'services',
    title: 'Услуги',
    icon: <Briefcase className="w-4 h-4 text-indigo-500" data-id="element-17429" />,
    bg: 'bg-indigo-50',
    links: [{
      label: 'Натальная карта',
      page: 'service-natal',
      icon: <Star className="w-3.5 h-3.5" data-id="element-17430" />
    }, {
      label: 'Соляр',
      page: 'service-solar',
      icon: <Sun className="w-3.5 h-3.5" data-id="element-17431" />
    }, {
      label: 'Совместимость',
      page: 'service-compatibility',
      icon: <Heart className="w-3.5 h-3.5" data-id="element-17432" />
    }, {
      label: 'Комбо-анализ',
      page: 'service-combo',
      icon: <FileText className="w-3.5 h-3.5" data-id="element-17433" />
    }, {
      label: 'Прогноз транзитов',
      page: 'service-forecast',
      icon: <Calendar className="w-3.5 h-3.5" data-id="element-17434" />
    }, {
      label: 'Консультации',
      page: 'service-consultation',
      icon: <MessageSquare className="w-3.5 h-3.5" data-id="element-17435" />
    }, {
      label: 'Цены и пакеты',
      page: 'pricing',
      icon: <Star className="w-3.5 h-3.5" data-id="element-17436" />
    }]
  }, {
    id: 'knowledge',
    title: 'Знания',
    icon: <BookOpen className="w-4 h-4 text-amber-500" data-id="element-17437" />,
    bg: 'bg-amber-50',
    links: [{
      label: 'Астро-календарь',
      page: 'astro-daily',
      icon: <Calendar className="w-3.5 h-3.5" data-id="element-17438" />
    }, {
      label: 'Блог',
      page: 'blog',
      icon: <FileText className="w-3.5 h-3.5" data-id="element-17439" />
    }, {
      label: 'Вопросы и ответы',
      page: 'faq',
      icon: <HelpCircle className="w-3.5 h-3.5" data-id="element-17440" />
    }]
  }, {
    id: 'company',
    title: 'Компания',
    icon: <Building className="w-4 h-4 text-emerald-500" data-id="element-17441" />,
    bg: 'bg-emerald-50',
    links: [{
      label: 'О нас',
      page: 'about',
      icon: <Info className="w-3.5 h-3.5" data-id="element-17442" />
    }, {
      label: 'Контакты',
      page: 'contact',
      icon: <Mail className="w-3.5 h-3.5" data-id="element-17443" />
    }, {
      label: 'Для астрологов',
      page: 'for-astrologers',
      icon: <Star className="w-3.5 h-3.5" data-id="element-17444" />
    }, {
      label: 'Реклама на сайте',
      page: 'advertising',
      icon: <FileText className="w-3.5 h-3.5" data-id="element-17445" />
    }]
  }, {
    id: 'support',
    title: 'Поддержка',
    icon: <HelpCircle className="w-4 h-4 text-rose-500" data-id="element-17446" />,
    bg: 'bg-rose-50',
    links: [{
      label: 'FAQ',
      page: 'faq',
      icon: <HelpCircle className="w-3.5 h-3.5" data-id="element-17447" />
    }, {
      label: 'Условия использования',
      page: 'terms',
      icon: <FileText className="w-3.5 h-3.5" data-id="element-17448" />
    }, {
      label: 'Конфиденциальность',
      page: 'privacy',
      icon: <Shield className="w-3.5 h-3.5" data-id="element-17449" />
    }, {
      label: 'Публичная оферта',
      page: 'public-offer',
      icon: <FileText className="w-3.5 h-3.5" data-id="element-17450" />
    }]
  }];
  return <div className="lg:hidden bg-white border-t border-slate-100 shadow-2xl absolute left-0 top-full w-full max-h-[calc(100vh-64px)] overflow-y-auto z-[999] flex flex-col" data-id="element-17451">
      <div className="p-4 space-y-4 flex-grow" data-id="element-17452">
        {/* 1. Главный CTA */}
        <button onClick={() => handleNavClick('free-chart')} className="flex items-center justify-center gap-2 w-full px-4 py-4 text-white bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 rounded-xl font-bold text-base shadow-md active:scale-[0.98] transition-all" data-id="element-17453">
          <Sparkles className="w-5 h-5" data-id="element-17454" />
          Бесплатный расчёт карты
        </button>

        {/* 2. Быстрые переходы */}
        <div className="grid grid-cols-3 gap-2" data-id="element-17455">
          <button onClick={() => handleNavClick('astrologers')} className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg border transition-colors ${currentPage === 'astrologers' ? 'bg-indigo-50 border-indigo-100 text-indigo-700' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`} data-id="element-17456">
            <Users className="w-4 h-4" data-id="element-17457" />
            <span className="text-xs font-semibold" data-id="element-17458">Астрологи</span>
          </button>
          <button onClick={() => {
          setOpenAccordion(openAccordion === 'services' ? null : 'services');
          document.getElementById('accordion-services')?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }} className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg border transition-colors ${openAccordion === 'services' ? 'bg-indigo-50 border-indigo-100 text-indigo-700' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`} data-id="element-17459">
            <Briefcase className="w-4 h-4" data-id="element-17460" />
            <span className="text-xs font-semibold" data-id="element-17461">Услуги</span>
          </button>
          <button onClick={() => handleNavClick('pricing')} className={`flex items-center justify-center gap-1.5 py-2.5 px-2 rounded-lg border transition-colors ${currentPage === 'pricing' ? 'bg-indigo-50 border-indigo-100 text-indigo-700' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`} data-id="element-17462">
            <Star className="w-4 h-4" data-id="element-17463" />
            <span className="text-xs font-semibold" data-id="element-17464">Цены</span>
          </button>
        </div>

        <div className="h-px bg-slate-100 my-2" data-id="element-17465" />

        {/* 3. Основная навигация (Аккордеоны) */}
        <div className="space-y-2" data-id="element-17466">
          {accordions.map(acc => <div key={acc.id} id={`accordion-${acc.id}`} className="rounded-xl border border-slate-100 overflow-hidden bg-white" data-id="element-17467">
              <button onClick={() => toggleAccordion(acc.id)} className="flex items-center justify-between w-full px-4 py-3.5 text-left hover:bg-slate-50 transition-colors" data-id="element-17468">
                <div className="flex items-center gap-3" data-id="element-17469">
                  <div className={`w-8 h-8 rounded-lg ${acc.bg} flex items-center justify-center`} data-id="element-17470">
                    {acc.icon}
                  </div>
                  <span className="text-sm font-bold text-slate-800" data-id="element-17471">
                    {acc.title}
                  </span>
                </div>
                <ChevronDown className={`w-4 h-4 text-slate-400 transition-transform duration-200 ${openAccordion === acc.id ? 'rotate-180' : ''}`} data-id="element-17472" />
              </button>

              {openAccordion === acc.id && <div className="px-3 pb-3 pt-1 border-t border-slate-50 bg-slate-50/50" data-id="element-17473">
                  <div className="space-y-1" data-id="element-17474">
                    {acc.links.map((link, idx) => <button key={idx} onClick={() => handleNavClick(link.page)} className="flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm text-slate-600 hover:text-indigo-600 hover:bg-white active:bg-white transition-all" data-id="element-17475">
                        <span className="text-slate-400" data-id="element-17476">{link.icon}</span>
                        <span className="font-medium" data-id="element-17477">{link.label}</span>
                      </button>)}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>

      {/* 4. Нижний блок */}
      <div className="p-4 bg-slate-50 border-t border-slate-100 mt-auto" data-id="element-17478">
        <div className="space-y-3" data-id="element-17479">
          {/* Auth / Profile */}
          {isLoggedIn ? <div className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-id="element-17480">
              <div className="flex items-center gap-3 px-4 py-3 border-b border-slate-100" data-id="element-17481">
                <div className="w-8 h-8 rounded-full bg-gradient-to-br from-indigo-100 to-purple-100 flex items-center justify-center flex-shrink-0" data-id="element-17482">
                  <span className="text-xs font-bold text-indigo-700 uppercase" data-id="element-17483">
                    {user?.name?.charAt(0) || 'U'}
                  </span>
                </div>
                <div className="min-w-0" data-id="element-17484">
                  <div className="text-sm font-bold text-slate-900 truncate" data-id="element-17485">
                    {user?.name}
                  </div>
                  <div className="text-xs text-slate-500 truncate" data-id="element-17486">
                    {user?.email}
                  </div>
                </div>
              </div>
              <div className="p-1.5 flex gap-1.5" data-id="element-17487">
                <button onClick={() => handleNavClick(user?.role === 'astrologer' ? 'dashboard-astrologer' : 'dashboard-user')} className="flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-xs font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-17488">
                  <LayoutDashboard className="w-3.5 h-3.5 text-slate-400" data-id="element-17489" />
                  Кабинет
                </button>
                <button onClick={() => {
              onLogout();
            }} className="flex-1 flex items-center justify-center gap-2 py-2 rounded-lg text-xs font-medium text-rose-600 hover:bg-rose-50 transition-colors" data-id="element-17490">
                  <LogOut className="w-3.5 h-3.5 text-rose-400" data-id="element-17491" />
                  Выйти
                </button>
              </div>
            </div> : <button onClick={() => handleNavClick('login')} className="flex items-center justify-center gap-2 w-full px-4 py-3 rounded-xl text-sm font-bold text-slate-700 bg-white border border-slate-200 shadow-sm active:bg-slate-50 transition-colors" data-id="element-17492">
              <UserIcon className="w-4 h-4 text-slate-400" data-id="element-17493" />
              Войти в личный кабинет
            </button>}

          {/* Secondary links & Language */}
          <div className="flex items-center justify-between pt-2" data-id="element-17494">
            {!isLoggedIn && <button onClick={() => handleNavClick('for-astrologers')} className="text-xs font-medium text-indigo-600 hover:text-indigo-700 transition-colors" data-id="element-17495">
                Для астрологов
              </button>}

            <div className={`flex items-center gap-1 ${isLoggedIn ? 'w-full justify-center' : ''}`} data-id="element-17496">
              {langOptions.map(lang => <button key={lang.code} onClick={() => setLanguage(lang.code)} className={`px-2 py-1 rounded text-[10px] font-medium transition-colors ${language === lang.code ? 'bg-slate-200 text-slate-800' : 'text-slate-500 hover:bg-slate-100'}`} data-id="element-17497">
                  {lang.flag} {lang.code.toUpperCase()}
                </button>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}